import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import HeadingForDashboardReusable from "../../../../reusable-components/headings/HeadingForDashboardReusable";
import {
  NOC_PRIMARY,
  NOC_SECONDARY,
} from "../../../../utilities/constants/colors";

ChartJS.register(ArcElement, Tooltip, Legend);

const NocReportCountVerifiedAndUnVerified = ({ data }) => {
  const verified = Number(data?.total_verified_noc) || 0;
  const unverified = Number(data?.total_unverified_noc) || 0;
  const total = verified + unverified;

  const chartData = {
    labels: ["Verified", "Unverified"],
    datasets: [
      {
        data: [verified, unverified],
        backgroundColor: [NOC_PRIMARY, NOC_SECONDARY],
        hoverBackgroundColor: ["#0a3a5c", "#94a3b8"],
        borderWidth: 0,
        cutout: "70%",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#475569",
          usePointStyle: true,
          pointStyle: "circle",
          padding: 16,
          font: { size: 12 },
        },
      },
      tooltip: {
        backgroundColor: NOC_PRIMARY,
        padding: 10,
        cornerRadius: 6,
        callbacks: {
          label: (ctx) => {
            const value = ctx.parsed;
            const pct = total ? ((value / total) * 100).toFixed(1) : 0;
            return ` ${ctx.label}: ${value.toLocaleString("en-IN")} (${pct}%)`;
          },
        },
      },
    },
  };

  return (
    <div>
      <HeadingForDashboardReusable
        title="NOC Verification Summary"
        description="Overview of verified and unverified NOC applications."
      />
      <div className="w-full rounded-xl border border-slate-200 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
        <div className="relative h-72 w-full">
          <Doughnut data={chartData} options={options} />

          {/* Center label */}
          <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center pb-10">
            <span className="text-2xl font-bold text-slate-900 dark:text-white">
              {total.toLocaleString("en-IN")}
            </span>
            <span className="text-xs uppercase tracking-wide text-slate-500">
              Total NOC
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NocReportCountVerifiedAndUnVerified;
